import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Truck } from "lucide-react";
import Logo from "../Assets/NSIRLOGO.png";
import "./Css/Navbar.css";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();
  const isHomeRoute = location.pathname === "/";
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/fleet", label: "Fleet" },
    { path: "/testimonials", label: "Testimonials" },
    { path: "/contact", label: "Contact" },
  ];
  const handleNavigate = (path) => {
    window.location.href = path;
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "shadow-lg bgWhiteClass" : "Bgtranpart"
      } ${
        isHomeRoute
          ? scrolled
            ? "homePageClass"
            : "homePageClassTransparent"
          : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <Link to="/" className="flex items-center">
            <div className="flex items-center">
              <img className="logoImg" src={Logo} alt="Logo"></img>{" "}
              <span className="text-xl font-bold text-gray-800">NSIR</span>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <div
                key={link.path}
                onClick={() => handleNavigate(link.path)}
                className={`cursor-pointer relative ${
                  location.pathname === link.path
                    ? "text-[#F80D01]"
                    : "text-gray-700 hover:text-[#F80D01]"
                } transition-colors`}
              >
                <span className="inline-block">{link.label}</span>
                {location.pathname === link.path && (
                  <div className="absolute left-0 right-0 h-0.5 bg-[#F80D01]" />
                )}
              </div>
            ))}
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700"
            >
              {isOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-3 py-2 ${
                  location.pathname === link.path
                    ? "text-[#F80D01]"
                    : "text-gray-700"
                } hover:text-[#F80D01] transition-colors`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
